import type { ModelConfig, RootState, SelectorCreator, Slicer } from '@swf/core/store';
import { select } from '@swf/core/store';

export type LocaleState = string;

const reducers = {
  set: (state: LocaleState, payload: string) => payload
};
const selectors = (slice: Slicer<LocaleState>, createSelector: SelectorCreator) => ({
  get() {
    return slice;
  },
  getIntlLocale() {
    return createSelector(
      slice,
      (rootState: RootState) => select.country.getCountry(rootState),
      (rootState: RootState) => select.account.getCountry(rootState),
      (state, geoCountry, accountCountry) => {
        const country = accountCountry || geoCountry;
        try {
          // @ts-ignore https://github.com/microsoft/TypeScript/issues/46907
          const [locale] = Intl.getCanonicalLocales(`${state}-${country}`);
          return locale;
        } catch (err) {
          return state;
        }
      }
    );
  }
});

export interface LocaleModel extends ModelConfig<LocaleState> {
  reducers: typeof reducers;
  selectors: typeof selectors;
}

const locale: LocaleModel = {
  state: 'en',
  reducers,
  selectors
};

export default locale;
